<template>
  <div class="public-lease-audit-header" data-theme="v1">
    <img src="/img/logos/new-logo.jpeg" alt="CRESiteIQ" class="public-lease-audit-header__logo" />
    <h1 class="public-lease-audit-header__title">{{ title }}</h1>
    
    <!-- Right Side: Toolbox Link, Email (if provided) and Theme Toggle -->
    <div class="public-lease-audit-header__header-right">
      <!-- Toolbox Link -->
      <a href="/toolbox" class="public-lease-audit-header__toolbox-link">
        <svg 
          class="public-lease-audit-header__toolbox-icon"
          viewBox="0 0 24 24" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg"
        >
          <path 
            d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" 
            stroke="currentColor" 
            stroke-width="2" 
            stroke-linecap="round" 
            stroke-linejoin="round"
          />
        </svg>
        <span class="public-lease-audit-header__toolbox-text">Toolbox</span>
      </a>

      <!-- User Info - only show if name is provided -->
      <div v-if="userName" class="public-lease-audit-header__user">
        <div class="public-lease-audit-header__user-icon">
          <svg 
            class="public-lease-audit-header__user-icon-svg"
            viewBox="0 0 24 24" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <path 
              d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" 
              stroke="currentColor" 
              stroke-width="2" 
              stroke-linecap="round" 
              stroke-linejoin="round"
            />
            <circle 
              cx="12" 
              cy="7" 
              r="4" 
              stroke="currentColor" 
              stroke-width="2" 
              stroke-linecap="round" 
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <div class="public-lease-audit-header__user-info">
          <span class="public-lease-audit-header__user-name">{{ userName }}</span>
        </div>
      </div>

      <!-- Theme Toggle -->
      <div class="public-lease-audit-header__theme-toggle">
        <theme-toggle />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PublicLeaseAuditHeader',

  props: {
    title: {
      type: String,
      default: 'Professional Lease Audit'
    }
  },

  data() {
    return {
      userName: null,
      userEmail: null,
      userPhone: null
    };
  },

  mounted() {
    // Check if user info is in URL parameters or sessionStorage
    const urlParams = new URLSearchParams(window.location.search);
    const emailFromUrl = urlParams.get('email');
    const nameFromUrl = urlParams.get('name');
    const phoneFromUrl = urlParams.get('phone');
    
    const emailFromSession = sessionStorage.getItem('public_view_email');
    const nameFromSession = sessionStorage.getItem('public_view_name');
    const phoneFromSession = sessionStorage.getItem('public_view_phone');
    
    this.userEmail = emailFromUrl || emailFromSession;
    this.userName = nameFromUrl || nameFromSession;
    this.userPhone = phoneFromUrl || phoneFromSession;
  }
};
</script>
